export default {
  allExpenses: [],
}
